export const state = {
  // product: undefined,
  // products: []
  site: {},
  sites: [],
  pagination:''
}
